module.exports = __webpack_public_path__ + "static/media/mind-control.bf6b7d2f.jpg";